import { simpleEditNotification } from 'hooks/notificationHandler'
import { useEditGoogleSheetPayItemConnectionMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'

export function useEditGoogleSheetPayItemConnection() {
  const [edit] = useEditGoogleSheetPayItemConnectionMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editGoogleSheetPayItemConnection: {
        googleSheet: {
          title,
          connection: { name },
        },
      },
    }) => simpleEditNotification(name ?? title ?? 'Google Sheet'),
  })
  return edit
}
